import PATHS from "utils/paths";

export const PAYMENT_METHODS_DOCS_INFO = [
  {
    title: "Payment methods",
    header:
      "Select which payment methods to make available within checkout for this payment link.",
    subheader:
      "There are restrictions around which payment methods can be used with different price types and currencies. Accounts may have to request access to certain payment methods (e.g. Afterpay / Clearpay) from within their Stripe dashboard. You can learn more about those restrictions within the documentation."
  }
];

export const CODE_PREVIEW_MAX_HEIGHT = {
  0: 180,
  1: 260,
  2: 380
};

export const DISCORD_SERVER_INVITE_URL = "https://discord.gg/PhFdFD2HvU";

const DEFINITION = "definition";

export const TABLE_TYPE = {
  DEFINITION
};

const ALWAYS = "always";
const CONDITIONALLY = "conditionally";
const OPTIONAL = "optional";

export const REQUIRED_TYPE = {
  ALWAYS,
  CONDITIONALLY,
  OPTIONAL
};

export const REQUIRED_TYPE_COPY = {
  [REQUIRED_TYPE.ALWAYS]: "required",
  [REQUIRED_TYPE.CONDITIONALLY]: "required conditionally",
  [REQUIRED_TYPE.OPTIONAL]: "optional"
};

export const HUB_DEV_SETTINGS = `${PATHS.HUB}?redirectTo=/settings?tab=development`;

const CURL = "cURL";
const JAVASCRIPT = "javascript";
const LANGUAGE_TYPE = {
  CURL,
  JAVASCRIPT
};

export const LANGUAGE_LABEL_MAP = {
  [LANGUAGE_TYPE.CURL]: CURL,
  [LANGUAGE_TYPE.JAVASCRIPT]: "JavaScript"
};

export const NO_INDENT_LANGUAGES = [
  LANGUAGE_TYPE.CURL,
  LANGUAGE_TYPE.JAVASCRIPT
];

const CALLOUT = "callout";
export const NODE_UID = {
  CALLOUT
};
